// extracted by mini-css-extract-plugin
export default {"changeValue":"bt_gH","positive":"bt_gF","negative":"bt_gG"};